/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfBoolean } from '../models/custom-result-of-boolean';
import { CustomResultOfDateTime } from '../models/custom-result-of-date-time';
import { CustomResultOfGetIsAuthenticatedByIdDto2 } from '../models/custom-result-of-get-is-authenticated-by-id-dto-2';
import { CustomResultOfGetUserByUserGuidDto } from '../models/custom-result-of-get-user-by-user-guid-dto';
import { CustomResultOfGetUserLastLoginInfosDto } from '../models/custom-result-of-get-user-last-login-infos-dto';
import { CustomResultOfListOfDownloadAllUserDocumentsDto } from '../models/custom-result-of-list-of-download-all-user-documents-dto';
import { CustomResultOfListOfGetCurrentOrganizationUsersListDto } from '../models/custom-result-of-list-of-get-current-organization-users-list-dto';
import { CustomResultOfListOfGetDistinctUsersListDto } from '../models/custom-result-of-list-of-get-distinct-users-list-dto';
import { CustomResultOfListOfGetUserLoginsInfosDto } from '../models/custom-result-of-list-of-get-user-logins-infos-dto';
import { CustomResultOfListOfGetUserOrganizationsDto } from '../models/custom-result-of-list-of-get-user-organizations-dto';
import { CustomResultOfListOfGetUsersListByOrganizationIdDto } from '../models/custom-result-of-list-of-get-users-list-by-organization-id-dto';
import { CustomResultOfListOfGetUsersListDescendantDto } from '../models/custom-result-of-list-of-get-users-list-descendant-dto';
import { CustomResultOfListOfGetUsersListDto } from '../models/custom-result-of-list-of-get-users-list-dto';
import { CustomResultOfListOfGetUsersListForAccessOrganizationDto } from '../models/custom-result-of-list-of-get-users-list-for-access-organization-dto';
import { CustomResultOfLong } from '../models/custom-result-of-long';
import { CustomResultOfPaginatedListOfGetUsersWithPaginationByOrganizationIdDto } from '../models/custom-result-of-paginated-list-of-get-users-with-pagination-by-organization-id-dto';
import { CustomResultOfPaginatedListOfResellerUserWithPaginationDto } from '../models/custom-result-of-paginated-list-of-reseller-user-with-pagination-dto';
import { CustomResultOfPaginatedListOfUserWithPaginationDto } from '../models/custom-result-of-paginated-list-of-user-with-pagination-dto';
import { CustomResultOfResultModel } from '../models/custom-result-of-result-model';
import { CustomResultOfString } from '../models/custom-result-of-string';
import { CustomResultOfUserDto } from '../models/custom-result-of-user-dto';
import { CustomResultOfUserStateDto } from '../models/custom-result-of-user-state-dto';
import { CustomResultOfUserWithRolesDto } from '../models/custom-result-of-user-with-roles-dto';
import { usersAddOrDeleteMobile } from '../fn/users/users-add-or-delete-mobile';
import { UsersAddOrDeleteMobile$Params } from '../fn/users/users-add-or-delete-mobile';
import { usersCreateUserInfoGet } from '../fn/users/users-create-user-info-get';
import { UsersCreateUserInfoGet$Params } from '../fn/users/users-create-user-info-get';
import { usersCreateUserInfoPost } from '../fn/users/users-create-user-info-post';
import { UsersCreateUserInfoPost$Params } from '../fn/users/users-create-user-info-post';
import { usersCreateUsers } from '../fn/users/users-create-users';
import { UsersCreateUsers$Params } from '../fn/users/users-create-users';
import { usersDelete } from '../fn/users/users-delete';
import { UsersDelete$Params } from '../fn/users/users-delete';
import { usersDownloadAllUserDocuments } from '../fn/users/users-download-all-user-documents';
import { UsersDownloadAllUserDocuments$Params } from '../fn/users/users-download-all-user-documents';
import { usersGetCurrentOrganizationUsersList } from '../fn/users/users-get-current-organization-users-list';
import { UsersGetCurrentOrganizationUsersList$Params } from '../fn/users/users-get-current-organization-users-list';
import { usersGetCurrentUserEncryptedNationalCode } from '../fn/users/users-get-current-user-encrypted-national-code';
import { UsersGetCurrentUserEncryptedNationalCode$Params } from '../fn/users/users-get-current-user-encrypted-national-code';
import { usersGetCurrentUserExpireDate } from '../fn/users/users-get-current-user-expire-date';
import { UsersGetCurrentUserExpireDate$Params } from '../fn/users/users-get-current-user-expire-date';
import { usersGetIsAuthenticatedById } from '../fn/users/users-get-is-authenticated-by-id';
import { UsersGetIsAuthenticatedById$Params } from '../fn/users/users-get-is-authenticated-by-id';
import { usersGetIsUserExists } from '../fn/users/users-get-is-user-exists';
import { UsersGetIsUserExists$Params } from '../fn/users/users-get-is-user-exists';
import { usersGetOrganizationUsersList } from '../fn/users/users-get-organization-users-list';
import { UsersGetOrganizationUsersList$Params } from '../fn/users/users-get-organization-users-list';
import { usersGetOrganizationUsersLoginsInfos } from '../fn/users/users-get-organization-users-logins-infos';
import { UsersGetOrganizationUsersLoginsInfos$Params } from '../fn/users/users-get-organization-users-logins-infos';
import { usersGetResellerUsersWithPagination } from '../fn/users/users-get-reseller-users-with-pagination';
import { UsersGetResellerUsersWithPagination$Params } from '../fn/users/users-get-reseller-users-with-pagination';
import { usersGetUserById } from '../fn/users/users-get-user-by-id';
import { UsersGetUserById$Params } from '../fn/users/users-get-user-by-id';
import { usersGetUserByUserGuid } from '../fn/users/users-get-user-by-user-guid';
import { UsersGetUserByUserGuid$Params } from '../fn/users/users-get-user-by-user-guid';
import { usersGetUserCredit } from '../fn/users/users-get-user-credit';
import { UsersGetUserCredit$Params } from '../fn/users/users-get-user-credit';
import { usersGetUserLastLoginInfos } from '../fn/users/users-get-user-last-login-infos';
import { UsersGetUserLastLoginInfos$Params } from '../fn/users/users-get-user-last-login-infos';
import { usersGetUserLoginsInfos } from '../fn/users/users-get-user-logins-infos';
import { UsersGetUserLoginsInfos$Params } from '../fn/users/users-get-user-logins-infos';
import { usersGetUserOrganizations } from '../fn/users/users-get-user-organizations';
import { UsersGetUserOrganizations$Params } from '../fn/users/users-get-user-organizations';
import { usersGetUsersAudit } from '../fn/users/users-get-users-audit';
import { UsersGetUsersAudit$Params } from '../fn/users/users-get-users-audit';
import { usersGetUsersList } from '../fn/users/users-get-users-list';
import { UsersGetUsersList$Params } from '../fn/users/users-get-users-list';
import { usersGetUsersListByOrganizationId } from '../fn/users/users-get-users-list-by-organization-id';
import { UsersGetUsersListByOrganizationId$Params } from '../fn/users/users-get-users-list-by-organization-id';
import { usersGetUsersListDescendant } from '../fn/users/users-get-users-list-descendant';
import { UsersGetUsersListDescendant$Params } from '../fn/users/users-get-users-list-descendant';
import { usersGetUsersListForAccessOrganization } from '../fn/users/users-get-users-list-for-access-organization';
import { UsersGetUsersListForAccessOrganization$Params } from '../fn/users/users-get-users-list-for-access-organization';
import { usersGetUserState } from '../fn/users/users-get-user-state';
import { UsersGetUserState$Params } from '../fn/users/users-get-user-state';
import { usersGetUsersWithPagination } from '../fn/users/users-get-users-with-pagination';
import { UsersGetUsersWithPagination$Params } from '../fn/users/users-get-users-with-pagination';
import { usersGetUsersWithPaginationByOrganizationId } from '../fn/users/users-get-users-with-pagination-by-organization-id';
import { UsersGetUsersWithPaginationByOrganizationId$Params } from '../fn/users/users-get-users-with-pagination-by-organization-id';
import { usersGetUserTicketingToken } from '../fn/users/users-get-user-ticketing-token';
import { UsersGetUserTicketingToken$Params } from '../fn/users/users-get-user-ticketing-token';
import { usersIncreaseUserCreditById } from '../fn/users/users-increase-user-credit-by-id';
import { UsersIncreaseUserCreditById$Params } from '../fn/users/users-increase-user-credit-by-id';
import { usersUpdateCurrentUserInfoGet } from '../fn/users/users-update-current-user-info-get';
import { UsersUpdateCurrentUserInfoGet$Params } from '../fn/users/users-update-current-user-info-get';
import { usersUpdateCurrentUserInfoPut } from '../fn/users/users-update-current-user-info-put';
import { UsersUpdateCurrentUserInfoPut$Params } from '../fn/users/users-update-current-user-info-put';
import { usersUpdatePasswordByUserIdGet } from '../fn/users/users-update-password-by-user-id-get';
import { UsersUpdatePasswordByUserIdGet$Params } from '../fn/users/users-update-password-by-user-id-get';
import { usersUpdatePasswordByUserIdPut } from '../fn/users/users-update-password-by-user-id-put';
import { UsersUpdatePasswordByUserIdPut$Params } from '../fn/users/users-update-password-by-user-id-put';
import { usersUpdateUserDocumentsStatus } from '../fn/users/users-update-user-documents-status';
import { UsersUpdateUserDocumentsStatus$Params } from '../fn/users/users-update-user-documents-status';
import { usersUpdateUserInfoGet } from '../fn/users/users-update-user-info-get';
import { UsersUpdateUserInfoGet$Params } from '../fn/users/users-update-user-info-get';
import { usersUpdateUserInfoPut } from '../fn/users/users-update-user-info-put';
import { UsersUpdateUserInfoPut$Params } from '../fn/users/users-update-user-info-put';
import { usersUpdateUserIsAuthenticated } from '../fn/users/users-update-user-is-authenticated';
import { UsersUpdateUserIsAuthenticated$Params } from '../fn/users/users-update-user-is-authenticated';
import { usersUpdateUserIsDefault } from '../fn/users/users-update-user-is-default';
import { UsersUpdateUserIsDefault$Params } from '../fn/users/users-update-user-is-default';
import { usersUpdateUserMobilePost } from '../fn/users/users-update-user-mobile-post';
import { UsersUpdateUserMobilePost$Params } from '../fn/users/users-update-user-mobile-post';
import { usersUpdateUserMobilePut } from '../fn/users/users-update-user-mobile-put';
import { UsersUpdateUserMobilePut$Params } from '../fn/users/users-update-user-mobile-put';
import { usersUploadUserDocuments } from '../fn/users/users-upload-user-documents';
import { UsersUploadUserDocuments$Params } from '../fn/users/users-upload-user-documents';
import { usersUserDocumentLink } from '../fn/users/users-user-document-link';
import { UsersUserDocumentLink$Params } from '../fn/users/users-user-document-link';

@Injectable({ providedIn: 'root' })
export class UsersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `usersGetUsersAudit()` */
  static readonly UsersGetUsersAuditPath = '/Users/GetUsersAudit';

  /**
   * Only for super admin, Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersGetUsersAudit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersGetUsersAudit$Response(params: UsersGetUsersAudit$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return usersGetUsersAudit(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for super admin, Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersGetUsersAudit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersGetUsersAudit(params: UsersGetUsersAudit$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.usersGetUsersAudit$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `usersGetUsersWithPagination()` */
  static readonly UsersGetUsersWithPaginationPath = '/Users/GetUsersWithPagination';

  /**
   * Get Users with paging - Use for Organizational Info.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersGetUsersWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersGetUsersWithPagination$Response(params: UsersGetUsersWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfUserWithPaginationDto>> {
    return usersGetUsersWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Users with paging - Use for Organizational Info.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersGetUsersWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersGetUsersWithPagination(params: UsersGetUsersWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfUserWithPaginationDto> {
    return this.usersGetUsersWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfUserWithPaginationDto>): CustomResultOfPaginatedListOfUserWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `usersGetResellerUsersWithPagination()` */
  static readonly UsersGetResellerUsersWithPaginationPath = '/Users/GetResellerUsersWithPagination';

  /**
   * دریافت کاربران سازمان های فروشنده فعلی با صفحه بندی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersGetResellerUsersWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersGetResellerUsersWithPagination$Response(params: UsersGetResellerUsersWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfResellerUserWithPaginationDto>> {
    return usersGetResellerUsersWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت کاربران سازمان های فروشنده فعلی با صفحه بندی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersGetResellerUsersWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersGetResellerUsersWithPagination(params: UsersGetResellerUsersWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfResellerUserWithPaginationDto> {
    return this.usersGetResellerUsersWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfResellerUserWithPaginationDto>): CustomResultOfPaginatedListOfResellerUserWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `usersGetUsersWithPaginationByOrganizationId()` */
  static readonly UsersGetUsersWithPaginationByOrganizationIdPath = '/Users/GetUsersWithPaginationByOrganizationId';

  /**
   * Get Users with paging by OrganizationId - Use ONLY for SuperAdmin.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersGetUsersWithPaginationByOrganizationId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersGetUsersWithPaginationByOrganizationId$Response(params: UsersGetUsersWithPaginationByOrganizationId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetUsersWithPaginationByOrganizationIdDto>> {
    return usersGetUsersWithPaginationByOrganizationId(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Users with paging by OrganizationId - Use ONLY for SuperAdmin.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersGetUsersWithPaginationByOrganizationId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersGetUsersWithPaginationByOrganizationId(params: UsersGetUsersWithPaginationByOrganizationId$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetUsersWithPaginationByOrganizationIdDto> {
    return this.usersGetUsersWithPaginationByOrganizationId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetUsersWithPaginationByOrganizationIdDto>): CustomResultOfPaginatedListOfGetUsersWithPaginationByOrganizationIdDto => r.body)
    );
  }

  /** Path part for operation `usersIncreaseUserCreditById()` */
  static readonly UsersIncreaseUserCreditByIdPath = '/Users/IncreaseUserCreditById';

  /**
   * Increase User Credit By Its Organization Credit.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersIncreaseUserCreditById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersIncreaseUserCreditById$Response(params: UsersIncreaseUserCreditById$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return usersIncreaseUserCreditById(this.http, this.rootUrl, params, context);
  }

  /**
   * Increase User Credit By Its Organization Credit.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersIncreaseUserCreditById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersIncreaseUserCreditById(params: UsersIncreaseUserCreditById$Params, context?: HttpContext): Observable<CustomResult> {
    return this.usersIncreaseUserCreditById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `usersGetUserByUserGuid()` */
  static readonly UsersGetUserByUserGuidPath = '/Users/GetUserByUserGuid';

  /**
   * Get User by UserGuid.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersGetUserByUserGuid()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetUserByUserGuid$Response(params?: UsersGetUserByUserGuid$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetUserByUserGuidDto>> {
    return usersGetUserByUserGuid(this.http, this.rootUrl, params, context);
  }

  /**
   * Get User by UserGuid.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersGetUserByUserGuid$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetUserByUserGuid(params?: UsersGetUserByUserGuid$Params, context?: HttpContext): Observable<CustomResultOfGetUserByUserGuidDto> {
    return this.usersGetUserByUserGuid$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetUserByUserGuidDto>): CustomResultOfGetUserByUserGuidDto => r.body)
    );
  }

  /** Path part for operation `usersGetUserById()` */
  static readonly UsersGetUserByIdPath = '/Users/GetUserById';

  /**
   * Get User by Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersGetUserById()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetUserById$Response(params?: UsersGetUserById$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfUserDto>> {
    return usersGetUserById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get User by Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersGetUserById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetUserById(params?: UsersGetUserById$Params, context?: HttpContext): Observable<CustomResultOfUserDto> {
    return this.usersGetUserById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfUserDto>): CustomResultOfUserDto => r.body)
    );
  }

  /** Path part for operation `usersGetUserLastLoginInfos()` */
  static readonly UsersGetUserLastLoginInfosPath = '/Users/GetUserLastLoginInfos';

  /**
   * Get user last login infos.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersGetUserLastLoginInfos()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetUserLastLoginInfos$Response(params?: UsersGetUserLastLoginInfos$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetUserLastLoginInfosDto>> {
    return usersGetUserLastLoginInfos(this.http, this.rootUrl, params, context);
  }

  /**
   * Get user last login infos.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersGetUserLastLoginInfos$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetUserLastLoginInfos(params?: UsersGetUserLastLoginInfos$Params, context?: HttpContext): Observable<CustomResultOfGetUserLastLoginInfosDto> {
    return this.usersGetUserLastLoginInfos$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetUserLastLoginInfosDto>): CustomResultOfGetUserLastLoginInfosDto => r.body)
    );
  }

  /** Path part for operation `usersGetUserLoginsInfos()` */
  static readonly UsersGetUserLoginsInfosPath = '/Users/GetUserLoginsInfos';

  /**
   * Get user logins infos.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersGetUserLoginsInfos()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetUserLoginsInfos$Response(params?: UsersGetUserLoginsInfos$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetUserLoginsInfosDto>> {
    return usersGetUserLoginsInfos(this.http, this.rootUrl, params, context);
  }

  /**
   * Get user logins infos.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersGetUserLoginsInfos$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetUserLoginsInfos(params?: UsersGetUserLoginsInfos$Params, context?: HttpContext): Observable<CustomResultOfListOfGetUserLoginsInfosDto> {
    return this.usersGetUserLoginsInfos$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetUserLoginsInfosDto>): CustomResultOfListOfGetUserLoginsInfosDto => r.body)
    );
  }

  /** Path part for operation `usersGetOrganizationUsersLoginsInfos()` */
  static readonly UsersGetOrganizationUsersLoginsInfosPath = '/Users/GetOrganizationUsersLoginsInfos';

  /**
   * Get organization users logins infos.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersGetOrganizationUsersLoginsInfos()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetOrganizationUsersLoginsInfos$Response(params?: UsersGetOrganizationUsersLoginsInfos$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetUserLoginsInfosDto>> {
    return usersGetOrganizationUsersLoginsInfos(this.http, this.rootUrl, params, context);
  }

  /**
   * Get organization users logins infos.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersGetOrganizationUsersLoginsInfos$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetOrganizationUsersLoginsInfos(params?: UsersGetOrganizationUsersLoginsInfos$Params, context?: HttpContext): Observable<CustomResultOfListOfGetUserLoginsInfosDto> {
    return this.usersGetOrganizationUsersLoginsInfos$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetUserLoginsInfosDto>): CustomResultOfListOfGetUserLoginsInfosDto => r.body)
    );
  }

  /** Path part for operation `usersGetIsUserExists()` */
  static readonly UsersGetIsUserExistsPath = '/Users/GetIsUserExists';

  /**
   * Get Is User Exists.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersGetIsUserExists()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetIsUserExists$Response(params?: UsersGetIsUserExists$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfBoolean>> {
    return usersGetIsUserExists(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Is User Exists.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersGetIsUserExists$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetIsUserExists(params?: UsersGetIsUserExists$Params, context?: HttpContext): Observable<CustomResultOfBoolean> {
    return this.usersGetIsUserExists$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfBoolean>): CustomResultOfBoolean => r.body)
    );
  }

  /** Path part for operation `usersGetUserState()` */
  static readonly UsersGetUserStatePath = '/Users/GetUserState';

  /**
   * Get User State.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersGetUserState()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetUserState$Response(params?: UsersGetUserState$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfUserStateDto>> {
    return usersGetUserState(this.http, this.rootUrl, params, context);
  }

  /**
   * Get User State.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersGetUserState$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetUserState(params?: UsersGetUserState$Params, context?: HttpContext): Observable<CustomResultOfUserStateDto> {
    return this.usersGetUserState$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfUserStateDto>): CustomResultOfUserStateDto => r.body)
    );
  }

  /** Path part for operation `usersGetUsersList()` */
  static readonly UsersGetUsersListPath = '/Users/GetUsersList';

  /**
   * Get list of Users.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersGetUsersList()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetUsersList$Response(params?: UsersGetUsersList$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetUsersListDto>> {
    return usersGetUsersList(this.http, this.rootUrl, params, context);
  }

  /**
   * Get list of Users.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersGetUsersList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetUsersList(params?: UsersGetUsersList$Params, context?: HttpContext): Observable<CustomResultOfListOfGetUsersListDto> {
    return this.usersGetUsersList$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetUsersListDto>): CustomResultOfListOfGetUsersListDto => r.body)
    );
  }

  /** Path part for operation `usersGetOrganizationUsersList()` */
  static readonly UsersGetOrganizationUsersListPath = '/Users/GetOrganizationUsersList';

  /**
   * Get Distinct Users List.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersGetOrganizationUsersList()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetOrganizationUsersList$Response(params?: UsersGetOrganizationUsersList$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetDistinctUsersListDto>> {
    return usersGetOrganizationUsersList(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Distinct Users List.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersGetOrganizationUsersList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetOrganizationUsersList(params?: UsersGetOrganizationUsersList$Params, context?: HttpContext): Observable<CustomResultOfListOfGetDistinctUsersListDto> {
    return this.usersGetOrganizationUsersList$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetDistinctUsersListDto>): CustomResultOfListOfGetDistinctUsersListDto => r.body)
    );
  }

  /** Path part for operation `usersGetUserOrganizations()` */
  static readonly UsersGetUserOrganizationsPath = '/Users/GetUserOrganizations';

  /**
   * Get list of user's Organizations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersGetUserOrganizations()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetUserOrganizations$Response(params?: UsersGetUserOrganizations$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetUserOrganizationsDto>> {
    return usersGetUserOrganizations(this.http, this.rootUrl, params, context);
  }

  /**
   * Get list of user's Organizations.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersGetUserOrganizations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetUserOrganizations(params?: UsersGetUserOrganizations$Params, context?: HttpContext): Observable<CustomResultOfListOfGetUserOrganizationsDto> {
    return this.usersGetUserOrganizations$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetUserOrganizationsDto>): CustomResultOfListOfGetUserOrganizationsDto => r.body)
    );
  }

  /** Path part for operation `usersGetUsersListForAccessOrganization()` */
  static readonly UsersGetUsersListForAccessOrganizationPath = '/Users/GetUsersListForAccessOrganization';

  /**
   * Get list of Users for Access Organization.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersGetUsersListForAccessOrganization()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetUsersListForAccessOrganization$Response(params?: UsersGetUsersListForAccessOrganization$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetUsersListForAccessOrganizationDto>> {
    return usersGetUsersListForAccessOrganization(this.http, this.rootUrl, params, context);
  }

  /**
   * Get list of Users for Access Organization.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersGetUsersListForAccessOrganization$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetUsersListForAccessOrganization(params?: UsersGetUsersListForAccessOrganization$Params, context?: HttpContext): Observable<CustomResultOfListOfGetUsersListForAccessOrganizationDto> {
    return this.usersGetUsersListForAccessOrganization$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetUsersListForAccessOrganizationDto>): CustomResultOfListOfGetUsersListForAccessOrganizationDto => r.body)
    );
  }

  /** Path part for operation `usersGetUsersListDescendant()` */
  static readonly UsersGetUsersListDescendantPath = '/Users/GetUsersListDescendant';

  /**
   * Get list of All Children Users.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersGetUsersListDescendant()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetUsersListDescendant$Response(params?: UsersGetUsersListDescendant$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetUsersListDescendantDto>> {
    return usersGetUsersListDescendant(this.http, this.rootUrl, params, context);
  }

  /**
   * Get list of All Children Users.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersGetUsersListDescendant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetUsersListDescendant(params?: UsersGetUsersListDescendant$Params, context?: HttpContext): Observable<CustomResultOfListOfGetUsersListDescendantDto> {
    return this.usersGetUsersListDescendant$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetUsersListDescendantDto>): CustomResultOfListOfGetUsersListDescendantDto => r.body)
    );
  }

  /** Path part for operation `usersGetUserCredit()` */
  static readonly UsersGetUserCreditPath = '/Users/GetUserCredit';

  /**
   * Get User Credit.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersGetUserCredit()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetUserCredit$Response(params?: UsersGetUserCredit$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfLong>> {
    return usersGetUserCredit(this.http, this.rootUrl, params, context);
  }

  /**
   * Get User Credit.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersGetUserCredit$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetUserCredit(params?: UsersGetUserCredit$Params, context?: HttpContext): Observable<CustomResultOfLong> {
    return this.usersGetUserCredit$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfLong>): CustomResultOfLong => r.body)
    );
  }

  /** Path part for operation `usersCreateUserInfoGet()` */
  static readonly UsersCreateUserInfoGetPath = '/Users/CreateUserInfo';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersCreateUserInfoGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersCreateUserInfoGet$Response(params?: UsersCreateUserInfoGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return usersCreateUserInfoGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersCreateUserInfoGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersCreateUserInfoGet(params?: UsersCreateUserInfoGet$Params, context?: HttpContext): Observable<Blob> {
    return this.usersCreateUserInfoGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `usersCreateUserInfoPost()` */
  static readonly UsersCreateUserInfoPostPath = '/Users/CreateUserInfo';

  /**
   * Create User Organizational Info.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersCreateUserInfoPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersCreateUserInfoPost$Response(params: UsersCreateUserInfoPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return usersCreateUserInfoPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create User Organizational Info.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersCreateUserInfoPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersCreateUserInfoPost(params: UsersCreateUserInfoPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.usersCreateUserInfoPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `usersUpdateUserInfoGet()` */
  static readonly UsersUpdateUserInfoGetPath = '/Users/UpdateUserInfo';

  /**
   * Get User by Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersUpdateUserInfoGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersUpdateUserInfoGet$Response(params?: UsersUpdateUserInfoGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfUserWithRolesDto>> {
    return usersUpdateUserInfoGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get User by Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersUpdateUserInfoGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersUpdateUserInfoGet(params?: UsersUpdateUserInfoGet$Params, context?: HttpContext): Observable<CustomResultOfUserWithRolesDto> {
    return this.usersUpdateUserInfoGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfUserWithRolesDto>): CustomResultOfUserWithRolesDto => r.body)
    );
  }

  /** Path part for operation `usersUpdateUserInfoPut()` */
  static readonly UsersUpdateUserInfoPutPath = '/Users/UpdateUserInfo';

  /**
   * Update User Organizational Info - Use for Admin and User.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersUpdateUserInfoPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersUpdateUserInfoPut$Response(params: UsersUpdateUserInfoPut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return usersUpdateUserInfoPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update User Organizational Info - Use for Admin and User.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersUpdateUserInfoPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersUpdateUserInfoPut(params: UsersUpdateUserInfoPut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.usersUpdateUserInfoPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `usersUpdateCurrentUserInfoGet()` */
  static readonly UsersUpdateCurrentUserInfoGetPath = '/Users/UpdateCurrentUserInfo';

  /**
   * Get Current User.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersUpdateCurrentUserInfoGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersUpdateCurrentUserInfoGet$Response(params?: UsersUpdateCurrentUserInfoGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfUserDto>> {
    return usersUpdateCurrentUserInfoGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Current User.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersUpdateCurrentUserInfoGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersUpdateCurrentUserInfoGet(params?: UsersUpdateCurrentUserInfoGet$Params, context?: HttpContext): Observable<CustomResultOfUserDto> {
    return this.usersUpdateCurrentUserInfoGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfUserDto>): CustomResultOfUserDto => r.body)
    );
  }

  /** Path part for operation `usersUpdateCurrentUserInfoPut()` */
  static readonly UsersUpdateCurrentUserInfoPutPath = '/Users/UpdateCurrentUserInfo';

  /**
   * Update User Organizational Info - Use for Admin and User.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersUpdateCurrentUserInfoPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersUpdateCurrentUserInfoPut$Response(params: UsersUpdateCurrentUserInfoPut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return usersUpdateCurrentUserInfoPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update User Organizational Info - Use for Admin and User.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersUpdateCurrentUserInfoPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersUpdateCurrentUserInfoPut(params: UsersUpdateCurrentUserInfoPut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.usersUpdateCurrentUserInfoPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `usersUpdateUserIsDefault()` */
  static readonly UsersUpdateUserIsDefaultPath = '/Users/UpdateUserIsDefault';

  /**
   * Update field IsDefault of User.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersUpdateUserIsDefault()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersUpdateUserIsDefault$Response(params: UsersUpdateUserIsDefault$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return usersUpdateUserIsDefault(this.http, this.rootUrl, params, context);
  }

  /**
   * Update field IsDefault of User.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersUpdateUserIsDefault$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersUpdateUserIsDefault(params: UsersUpdateUserIsDefault$Params, context?: HttpContext): Observable<CustomResult> {
    return this.usersUpdateUserIsDefault$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `usersUpdateUserIsAuthenticated()` */
  static readonly UsersUpdateUserIsAuthenticatedPath = '/Users/UpdateUserIsAuthenticated';

  /**
   * Update field IsAuthenticated of User.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersUpdateUserIsAuthenticated()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersUpdateUserIsAuthenticated$Response(params: UsersUpdateUserIsAuthenticated$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return usersUpdateUserIsAuthenticated(this.http, this.rootUrl, params, context);
  }

  /**
   * Update field IsAuthenticated of User.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersUpdateUserIsAuthenticated$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersUpdateUserIsAuthenticated(params: UsersUpdateUserIsAuthenticated$Params, context?: HttpContext): Observable<CustomResult> {
    return this.usersUpdateUserIsAuthenticated$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `usersDelete()` */
  static readonly UsersDeletePath = '/Users/Delete';

  /**
   * Delete User.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersDelete$Response(params?: UsersDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return usersDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete User.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersDelete(params?: UsersDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.usersDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `usersUploadUserDocuments()` */
  static readonly UsersUploadUserDocumentsPath = '/Users/UploadUserDocuments';

  /**
   * Upload User Documents.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersUploadUserDocuments()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersUploadUserDocuments$Response(params: UsersUploadUserDocuments$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return usersUploadUserDocuments(this.http, this.rootUrl, params, context);
  }

  /**
   * Upload User Documents.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersUploadUserDocuments$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersUploadUserDocuments(params: UsersUploadUserDocuments$Params, context?: HttpContext): Observable<CustomResult> {
    return this.usersUploadUserDocuments$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `usersUpdateUserDocumentsStatus()` */
  static readonly UsersUpdateUserDocumentsStatusPath = '/Users/UpdateUserDocumentsStatus';

  /**
   * Update User Documents Status.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersUpdateUserDocumentsStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersUpdateUserDocumentsStatus$Response(params: UsersUpdateUserDocumentsStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return usersUpdateUserDocumentsStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * Update User Documents Status.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersUpdateUserDocumentsStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersUpdateUserDocumentsStatus(params: UsersUpdateUserDocumentsStatus$Params, context?: HttpContext): Observable<CustomResult> {
    return this.usersUpdateUserDocumentsStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `usersDownloadAllUserDocuments()` */
  static readonly UsersDownloadAllUserDocumentsPath = '/Users/DownloadAllUserDocuments';

  /**
   * Download All User Documents.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersDownloadAllUserDocuments()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersDownloadAllUserDocuments$Response(params?: UsersDownloadAllUserDocuments$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfDownloadAllUserDocumentsDto>> {
    return usersDownloadAllUserDocuments(this.http, this.rootUrl, params, context);
  }

  /**
   * Download All User Documents.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersDownloadAllUserDocuments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersDownloadAllUserDocuments(params?: UsersDownloadAllUserDocuments$Params, context?: HttpContext): Observable<CustomResultOfListOfDownloadAllUserDocumentsDto> {
    return this.usersDownloadAllUserDocuments$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfDownloadAllUserDocumentsDto>): CustomResultOfListOfDownloadAllUserDocumentsDto => r.body)
    );
  }

  /** Path part for operation `usersUserDocumentLink()` */
  static readonly UsersUserDocumentLinkPath = '/Users/UserDocumentLink';

  /**
   * Download User Document Link.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersUserDocumentLink()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersUserDocumentLink$Response(params?: UsersUserDocumentLink$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return usersUserDocumentLink(this.http, this.rootUrl, params, context);
  }

  /**
   * Download User Document Link.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersUserDocumentLink$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersUserDocumentLink(params?: UsersUserDocumentLink$Params, context?: HttpContext): Observable<Blob> {
    return this.usersUserDocumentLink$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `usersCreateUsers()` */
  static readonly UsersCreateUsersPath = '/Users/CreateUsers';

  /**
   * Create Users.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersCreateUsers()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersCreateUsers$Response(params: UsersCreateUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return usersCreateUsers(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Users.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersCreateUsers$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersCreateUsers(params: UsersCreateUsers$Params, context?: HttpContext): Observable<CustomResult> {
    return this.usersCreateUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `usersGetCurrentOrganizationUsersList()` */
  static readonly UsersGetCurrentOrganizationUsersListPath = '/Users/GetCurrentOrganizationUsersList';

  /**
   * Create Users.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersGetCurrentOrganizationUsersList()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetCurrentOrganizationUsersList$Response(params?: UsersGetCurrentOrganizationUsersList$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetCurrentOrganizationUsersListDto>> {
    return usersGetCurrentOrganizationUsersList(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Users.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersGetCurrentOrganizationUsersList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetCurrentOrganizationUsersList(params?: UsersGetCurrentOrganizationUsersList$Params, context?: HttpContext): Observable<CustomResultOfListOfGetCurrentOrganizationUsersListDto> {
    return this.usersGetCurrentOrganizationUsersList$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetCurrentOrganizationUsersListDto>): CustomResultOfListOfGetCurrentOrganizationUsersListDto => r.body)
    );
  }

  /** Path part for operation `usersGetUsersListByOrganizationId()` */
  static readonly UsersGetUsersListByOrganizationIdPath = '/Users/GetUsersListByOrganizationId';

  /**
   * Create Users.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersGetUsersListByOrganizationId()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetUsersListByOrganizationId$Response(params?: UsersGetUsersListByOrganizationId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetUsersListByOrganizationIdDto>> {
    return usersGetUsersListByOrganizationId(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Users.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersGetUsersListByOrganizationId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetUsersListByOrganizationId(params?: UsersGetUsersListByOrganizationId$Params, context?: HttpContext): Observable<CustomResultOfListOfGetUsersListByOrganizationIdDto> {
    return this.usersGetUsersListByOrganizationId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetUsersListByOrganizationIdDto>): CustomResultOfListOfGetUsersListByOrganizationIdDto => r.body)
    );
  }

  /** Path part for operation `usersGetIsAuthenticatedById()` */
  static readonly UsersGetIsAuthenticatedByIdPath = '/Users/GetIsAuthenticatedById';

  /**
   * Get User by Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersGetIsAuthenticatedById()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetIsAuthenticatedById$Response(params?: UsersGetIsAuthenticatedById$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetIsAuthenticatedByIdDto2>> {
    return usersGetIsAuthenticatedById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get User by Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersGetIsAuthenticatedById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetIsAuthenticatedById(params?: UsersGetIsAuthenticatedById$Params, context?: HttpContext): Observable<CustomResultOfGetIsAuthenticatedByIdDto2> {
    return this.usersGetIsAuthenticatedById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetIsAuthenticatedByIdDto2>): CustomResultOfGetIsAuthenticatedByIdDto2 => r.body)
    );
  }

  /** Path part for operation `usersGetCurrentUserExpireDate()` */
  static readonly UsersGetCurrentUserExpireDatePath = '/Users/GetCurrentUserExpireDate';

  /**
   * دریافت تاریخ انقضای کاربر فعلی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersGetCurrentUserExpireDate()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetCurrentUserExpireDate$Response(params?: UsersGetCurrentUserExpireDate$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfDateTime>> {
    return usersGetCurrentUserExpireDate(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت تاریخ انقضای کاربر فعلی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersGetCurrentUserExpireDate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetCurrentUserExpireDate(params?: UsersGetCurrentUserExpireDate$Params, context?: HttpContext): Observable<CustomResultOfDateTime> {
    return this.usersGetCurrentUserExpireDate$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfDateTime>): CustomResultOfDateTime => r.body)
    );
  }

  /** Path part for operation `usersUpdatePasswordByUserIdGet()` */
  static readonly UsersUpdatePasswordByUserIdGetPath = '/Users/UpdatePasswordByUserId';

  /**
   * ویرایش کلمه عبور کاربر.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersUpdatePasswordByUserIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersUpdatePasswordByUserIdGet$Response(params?: UsersUpdatePasswordByUserIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return usersUpdatePasswordByUserIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * ویرایش کلمه عبور کاربر.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersUpdatePasswordByUserIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersUpdatePasswordByUserIdGet(params?: UsersUpdatePasswordByUserIdGet$Params, context?: HttpContext): Observable<Blob> {
    return this.usersUpdatePasswordByUserIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `usersUpdatePasswordByUserIdPut()` */
  static readonly UsersUpdatePasswordByUserIdPutPath = '/Users/UpdatePasswordByUserId';

  /**
   * ویرایش کلمه عبور کاربر.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersUpdatePasswordByUserIdPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersUpdatePasswordByUserIdPut$Response(params: UsersUpdatePasswordByUserIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return usersUpdatePasswordByUserIdPut(this.http, this.rootUrl, params, context);
  }

  /**
   * ویرایش کلمه عبور کاربر.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersUpdatePasswordByUserIdPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersUpdatePasswordByUserIdPut(params: UsersUpdatePasswordByUserIdPut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.usersUpdatePasswordByUserIdPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `usersUpdateUserMobilePut()` */
  static readonly UsersUpdateUserMobilePutPath = '/Users/UpdateUserMobile';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersUpdateUserMobilePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersUpdateUserMobilePut$Response(params: UsersUpdateUserMobilePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return usersUpdateUserMobilePut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersUpdateUserMobilePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersUpdateUserMobilePut(params: UsersUpdateUserMobilePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.usersUpdateUserMobilePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `usersUpdateUserMobilePost()` */
  static readonly UsersUpdateUserMobilePostPath = '/Users/UpdateUserMobile';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersUpdateUserMobilePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersUpdateUserMobilePost$Response(params: UsersUpdateUserMobilePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return usersUpdateUserMobilePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersUpdateUserMobilePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersUpdateUserMobilePost(params: UsersUpdateUserMobilePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.usersUpdateUserMobilePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `usersGetUserTicketingToken()` */
  static readonly UsersGetUserTicketingTokenPath = '/Users/GetUserTicketingToken';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersGetUserTicketingToken()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersGetUserTicketingToken$Response(params: UsersGetUserTicketingToken$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfResultModel>> {
    return usersGetUserTicketingToken(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersGetUserTicketingToken$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersGetUserTicketingToken(params: UsersGetUserTicketingToken$Params, context?: HttpContext): Observable<CustomResultOfResultModel> {
    return this.usersGetUserTicketingToken$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfResultModel>): CustomResultOfResultModel => r.body)
    );
  }

  /** Path part for operation `usersAddOrDeleteMobile()` */
  static readonly UsersAddOrDeleteMobilePath = '/Users/AddOrDeleteMobile';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersAddOrDeleteMobile()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersAddOrDeleteMobile$Response(params: UsersAddOrDeleteMobile$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return usersAddOrDeleteMobile(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersAddOrDeleteMobile$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersAddOrDeleteMobile(params: UsersAddOrDeleteMobile$Params, context?: HttpContext): Observable<CustomResult> {
    return this.usersAddOrDeleteMobile$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `usersGetCurrentUserEncryptedNationalCode()` */
  static readonly UsersGetCurrentUserEncryptedNationalCodePath = '/Users/GetCurrentUserEncryptedNationalCode';

  /**
   * دریافت کدملی کاربر جاری (Encryption For BehPardakhtMellat).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersGetCurrentUserEncryptedNationalCode()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetCurrentUserEncryptedNationalCode$Response(params?: UsersGetCurrentUserEncryptedNationalCode$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfString>> {
    return usersGetCurrentUserEncryptedNationalCode(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت کدملی کاربر جاری (Encryption For BehPardakhtMellat).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersGetCurrentUserEncryptedNationalCode$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGetCurrentUserEncryptedNationalCode(params?: UsersGetCurrentUserEncryptedNationalCode$Params, context?: HttpContext): Observable<CustomResultOfString> {
    return this.usersGetCurrentUserEncryptedNationalCode$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfString>): CustomResultOfString => r.body)
    );
  }

}
